import { render, staticRenderFns } from "./ListingComponent.vue?vue&type=template&id=60a0bdc0&scoped=true&"
import script from "./ListingComponent.vue?vue&type=script&lang=js&"
export * from "./ListingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0bdc0",
  null
  
)

export default component.exports